import React from "react";
import LeftSidedImageCopyItem from '../../Partials/LeftSidedImageCopyItem/index'
import PropTypes from 'prop-types'

const LeftSidedImageCopyItemCollection = ({ data }) => {
  if (!Array.isArray(data) || (Array.isArray(data) && data.length < 1)) {
    return null;
  }

  return (
    <div>
      {data.map((item, i) => {
        return (
            <div key={i}>
            <LeftSidedImageCopyItem
              description={item.description}
              descriptionContent={item.descriptionContent}
              image={item.image}
              title={item.title}
            />
            </div>
        );
      })}
    </div>
  );
};

    LeftSidedImageCopyItemCollection.prototypes = {
      data : PropTypes.arrayOf(
        PropTypes.shape({
          // description : PropTypes.string,
          descriptionContent : PropTypes.node,
          image : PropTypes.string.isRequired,
          title : PropTypes.object
        })
      )
    }   

export default LeftSidedImageCopyItemCollection;
